
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bA2bP", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.a86297b3.js.map
